
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  className?: string;
  overlay?: boolean;
}

const LoadingSpinner = ({ 
  size = 'md', 
  text, 
  className = '', 
  overlay = false 
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  const content = (
    <div className={cn(
      "flex flex-col items-center justify-center gap-2",
      overlay && "fixed inset-0 bg-background/80 backdrop-blur-sm z-50",
      className
    )}>
      <Loader2 className={cn(
        "animate-spin text-primary",
        sizeClasses[size]
      )} />
      {text && (
        <p className={cn(
          "text-muted-foreground",
          textSizeClasses[size]
        )}>
          {text}
        </p>
      )}
    </div>
  );

  return content;
};

export default LoadingSpinner;
